module.exports = __webpack_public_path__ + "img/L_322_0.a96ec68b.png";